import type { OnboardingStartInput } from '@ballast/shared/schemas';

const API_BASE =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? 'http://localhost:8787';

export interface OnboardingStartResponse {
  ok: true;
  merchantId: string;
}

export async function submitOnboarding(
  input: OnboardingStartInput,
): Promise<OnboardingStartResponse> {
  const res = await fetch(`${API_BASE}/v1/onboarding/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as {
      error?: { issues?: Array<{ message: string }> };
    } | null;
    const message = body?.error?.issues?.[0]?.message ?? `Submission failed (${res.status})`;
    throw new Error(message);
  }
  return (await res.json()) as OnboardingStartResponse;
}

export interface OnboardingRow {
  id: string;
  status: 'pending' | 'kyb_in_review' | 'active' | 'suspended' | 'terminated';
  legalName: string;
  ownerName: string;
  ownerEmail: string;
  ownerPhone: string;
  businessType: string;
  monthlyVolumeEstimate: string;
  createdAt: string;
}

export interface FetchOnboardingsResponse {
  onboardings: OnboardingRow[];
}

export async function fetchOnboardings(bootstrapKey: string): Promise<FetchOnboardingsResponse> {
  const url = new URL(`${API_BASE}/v1/admin/bootstrap/onboardings`);
  url.searchParams.set('bootstrap_key', bootstrapKey);
  const res = await fetch(url.toString());
  if (res.status === 401) {
    throw new Error('Invalid bootstrap key');
  }
  if (res.status === 503) {
    throw new Error('Admin bootstrap not configured (ADMIN_BOOTSTRAP_KEY unset on the server)');
  }
  if (!res.ok) {
    throw new Error(`Fetch failed (${res.status})`);
  }
  return (await res.json()) as FetchOnboardingsResponse;
}
